import axios from "axios";
import { baseUrl } from "../util";

const getConfig = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    "Content-Type": "application/json",
  },
});

export const actionPlanInvestmentService = {
  getInvestments: async (effortId) => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/business/efforts/${effortId}/investments/`,
        getConfig()
      );
      return response.data.data;
    } catch (error) {
      console.error("Error fetching investments:", error);
      throw error;
    }
  },
  createInvestments: async (effortId, investmentData) => {
    try {
      const payload = {
        title: investmentData.title,
        description: investmentData.description,
        amount: investmentData.amount,
        currency: investmentData.currency,
      };

      const response = await axios.post(
        `${baseUrl}/api/business/efforts/${effortId}/investments/`,
        payload,
        getConfig()
      );
      return response.data.data;
    } catch (error) {
      console.error("Error creating investment:", error);
      throw error;
    }
  },

  updateInvestments: async (effortId, followUpId, investmentData) => {
    try {
      const payload = {
        title: investmentData.title,
        description: investmentData.description,
        amount: investmentData.amount,
        currency: investmentData.currency,
      };

      const response = await axios.put(
        `${baseUrl}/api/business/efforts/${effortId}/investments/${followUpId}/`,
        payload,
        getConfig()
      );
      return response.data.data;
    } catch (error) {
      console.error("Error updating investment:", error);
      throw error;
    }
  },

  deleteInvestments: async (effortId, followUpId) => {
    try {
      const response = await axios.delete(
        `${baseUrl}/api/business/efforts/${effortId}/investments/${followUpId}/`,
        getConfig()
      );
      return response.status === 204;
    } catch (error) {
      console.error("Error deleting investment:", error);
      throw error;
    }
  },
};

export default actionPlanInvestmentService;
